export const BOOZT_COOKIE_CONSENT_FEATURE = 'T80061_cookie_consent';
export const BOOZTLET_COOKIE_CONSENT_FEATURE = 'PLT-3019_cookie_consent';

export const ONETRUST_MOBILE_VIEWPORT = 530;
export const SPACING_VERTICAL = 16;

export const COOKIE_CONTENT_CLASS = 'ot-cookie-content-container';
export const COOKIES_COLUMN_CLASS = 'ot-cookies-td';
export const COOKIES_COLUMN_CONTENT_CLASS = 'ot-cookies-td-content';
export const HOST_COLUMN_CLASS = 'ot-host-td';
export const LIFE_SPAN_COLUMN_CLASS = 'ot-life-span-td';
export const LIFE_SPAN_COLUMN_CONTENT_CLASS = 'ot-life-span-td-content';
export const PURPOSE_COLUMN_CLASS = 'ot-description-td';
export const PURPOSE_COLUMN_CONTENT_CLASS = 'ot-description-td-content';

export const TABLE_HEADER_QUERY = '#ot-sdk-cookie-policy-v2 > section > table > thead > tr';
export const TABLE_ROWS_QUERY = '#ot-sdk-cookie-policy-v2 tbody tr';
export const TABLE_COOKIES_CELLS_QUERY = '#ot-sdk-cookie-policy-v2 .ot-cookies-td';
export const TABLE_COOKIES_VALUES_QUERY = '.ot-cookies-type:not(.ot-table-header)';
export const CONSENT_BANNER_FADE_QUERY = '#onetrust-consent-sdk > div.onetrust-pc-dark-filter.ot-fade-in';
